export default __webpack_public_path__ + "static/media/Touch_randomness.44aa22e4.svg";